var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"help-container"},[_c('span',{staticClass:"help-icon",style:({ top: _vm.top, right: _vm.right, }),on:{"click":function($event){_vm.displayHelp = !_vm.displayHelp}}},[_c('font-awesome-icon',{attrs:{"icon":_vm.displayHelp ? 'times-circle' : 'question-circle',"size":"lg"}})],1),_vm._v(" "),_c('transition',{attrs:{"name":"slide-fade"}},[(_vm.displayHelp)?_c('b-row',[_c('b-col',{staticClass:"pt-4 p-3 mb-2",class:{
          'pt-2' : _vm.displayHelp,
          'bottom-border': _vm.displayBorder,
        }},[_vm._t("default")],2)],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67b2cb50","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/hints/HelpHint.vue
// module id = null
// module chunks = 